"use client";

import React from "react";
import { ShieldCheck, Globe, Factory, FlaskConical, HardHat, Scale, ArrowRight } from "lucide-react";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";
import { Button } from "@/components/ui/button";
const complianceStandards = [{
  id: "asnzs-4671",
  title: "AS/NZS 4671",
  category: "Steel Reinforcing",
  icon: ShieldCheck,
  summary: "Certified steel reinforcing systems meeting Australian standards for mechanical properties, ensuring structural durability for high-load construction projects."
}, {
  id: "asnzs-3972",
  title: "AS/NZS 3972",
  category: "Cement & Concrete",
  icon: Factory,
  summary: "Strict adherence to AS/NZS 3972 for bulk cementitious materials, ensuring consistent performance and strength in all residential and industrial structural pours."
}, {
  id: "asnzs-4401",
  title: "AS/NZS 4401",
  category: "Plumbing & Piping",
  icon: FlaskConical,
  summary: "Full compliance with Australian standards for specialty piping, guaranteeing safe transport of chemical and fluid substances in heavy-duty wholesale supply."
}, {
  id: "whs-reg",
  title: "WHS Regs",
  category: "Safety Protocols",
  icon: HardHat,
  summary: "Comprehensive compliance with Safe Work Australia regulations, prioritizing the safety of our logistics team and your site personnel during bulk deliveries."
}, {
  id: "green-star",
  title: "Green Star",
  category: "Environmental",
  icon: Globe,
  summary: "Strategic sourcing of building materials that contribute to Green Star certification, supporting sustainable and energy-efficient Australian development."
}, {
  id: "asnzs-3000",
  title: "AS/NZS 3000",
  category: "Electrical",
  icon: Scale,
  summary: "Strict compliance with AS/NZS 3000:2018 Wiring Rules for all electrical hardware and wholesale components provided to our B2B contracting partners."
}];
export default function B2BComplianceStandards() {
  return <section data-section-id="140411" id="supply-standards" className="bg-background py-16 md:py-24">
      <div className="container mx-auto px-4">
        {}
        <div className="bg-muted border-2 border-border rounded-sm p-8 md:p-12 lg:p-16 shadow-2xl relative overflow-hidden">
          
          {}
          <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
          backgroundImage: 'radial-gradient(circle at 2px 2px, var(--border) 1px, transparent 0)',
          backgroundSize: '24px 24px'
        }}></div>

          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8 items-center relative z-10">
            
            {}
            <div className="lg:col-span-5 space-y-8">
              <div className="space-y-4">
                <div className="inline-flex items-center gap-2 px-3 py-1 bg-background/50 border border-border/50 rounded-sm text-foreground text-sm font-mono uppercase tracking-wider">
                  <ShieldCheck className="w-4 h-4 text-[var(--chart-1)]" />
                  <span>AS/NZS Certified</span>
                </div>
                <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-extrabold tracking-tighter text-foreground uppercase leading-[1.1]">
                  Rigorous <br />
                  <span className="text-[var(--chart-1)]">Standards.</span>
                </h2>
              </div>
              
              <p className="text-muted-foreground text-lg max-w-md leading-relaxed">
                BRENDON J BUILDING MATERIAL WHOLESALERS PTY LTD operates under strict Australian quality control protocols. Our vetted supply chain ensures every material meets the demanding specifications of Victoria's construction sector.
              </p>

              <div className="pt-4">
                <Button variant="default" size="lg" className="font-mono uppercase tracking-wide rounded-sm border-2 border-primary hover:bg-transparent hover:text-primary transition-colors">
                  Request Technical Specs
                  <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </div>
            </div>

            {}
            <div className="lg:col-span-7">
              <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
                {complianceStandards.map((standard, index) => <div key={standard.id} data-index={index}>
                    <HoverCard openDelay={100} closeDelay={100}>
                      <HoverCardTrigger asChild>
                        <div className="group cursor-help bg-card border-2 border-border rounded-sm p-6 flex flex-col items-center justify-center gap-4 transition-all duration-300 hover:border-[var(--chart-1)] hover:shadow-[0_0_20px_rgba(251,191,36,0.3)] hover:-translate-y-1 h-full min-h-[160px]">
                          <standard.icon className="w-10 h-10 text-muted-foreground group-hover:text-[var(--chart-1)] transition-colors duration-300" />
                          <div className="text-center space-y-1">
                            <h3 className="font-serif font-bold text-card-foreground uppercase tracking-tight">
                              {standard.title}
                            </h3>
                            <p className="text-xs font-mono text-muted-foreground uppercase tracking-wider">
                              {standard.category}
                            </p>
                          </div>
                        </div>
                      </HoverCardTrigger>
                      <HoverCardContent side="top" align="center" className="w-80 border-2 border-[var(--chart-1)] shadow-[0_0_30px_rgba(251,191,36,0.2)] bg-card rounded-sm p-5">
                        <div className="space-y-3">
                          <div className="flex items-center gap-3 border-b border-border pb-3">
                            <div className="p-2 bg-muted rounded-sm">
                              <standard.icon className="w-5 h-5 text-[var(--chart-1)]" />
                            </div>
                            <div>
                              <h4 className="font-serif text-base text-card-foreground uppercase leading-none">
                                {standard.title}
                              </h4>
                              <span className="text-xs font-mono text-[var(--chart-1)] uppercase tracking-wider">
                                Protocol Active
                              </span>
                            </div>
                          </div>
                          <p className="text-sm text-muted-foreground leading-relaxed">
                            {standard.summary}
                          </p>
                        </div>
                      </HoverCardContent>
                    </HoverCard>
                  </div>)}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>;
}